module.exports = __webpack_public_path__ + "static/img/aboutus_banner@2x.ba74aa22.png";